import { render } from "./deailsPartners.vue?vue&type=template&id=079f1d87"
import script from "./deailsPartners.vue?vue&type=script&lang=js"
export * from "./deailsPartners.vue?vue&type=script&lang=js"

import "./deailsPartners.vue?vue&type=style&index=0&id=079f1d87&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__